'use client';

import { createContext } from 'react';

import { ViewTabsEnum } from '@/layouts/PA-Layout/constants';

export interface ILayoutInfo {
  tabKey?: ViewTabsEnum;
  type?: 'chat' | 'genius' | 'pa' | 'log' | 'other';
  chatStatus?: 'hide' | 'normal' | 'fullScreen';
  biogStatus?: 'hide' | 'normal';
  voiceStatus?: 'hide' | 'normal';
  editStatus?: 'hide' | 'normal';
}

export const ContextGeniusLayout = createContext<ILayoutInfo>({
  tabKey: ViewTabsEnum.Home,
  type: 'pa',
  chatStatus: 'hide',
  biogStatus: 'hide',
  voiceStatus: 'hide',
  editStatus: 'hide'
});

interface IProps {
  layoutInfo: ILayoutInfo;
  children: React.ReactNode;
}

function ProviderGeniusLayout(props: IProps): JSX.Element {
  const { layoutInfo, children } = props;

  return <ContextGeniusLayout.Provider value={layoutInfo}>{children}</ContextGeniusLayout.Provider>;
}

export default ProviderGeniusLayout;
